export const faireStatusOptions: { id: string; value: string }[] = [
  { id: " ", value: "All status" },
  { id: "DRAFT", value: "Draft" },
  { id: "PUBLISHED", value: "Published" },
  { id: "UNPUBLISHED", value: "Unpublished" },
  { id: "DELETED", value: "Deleted" },
];


export const productStatusOptions: {id:string; value:string}[] = [
  { id: "", value: "All Products" },
  { id: "IMPORTED", value: "Imported" },
  { id: "EXPORTED", value: "Exported" },
  { id: "NOT_EXPORTED", value: "Not Exported" },
]